import { ENTITY_TYPES } from '@sportninja/common/sagas/utils'
import { isCanlan } from '@sportninja/common/utils/customer-name'

export const getEntityLabel = (entityType: string): string => {
  if (entityType === ENTITY_TYPES.org) {
    return isCanlan ? 'League' : 'Organization'
  }
  if (entityType === ENTITY_TYPES.schedule) {
    return isCanlan ? 'Season' : 'Competition'
  }
  return 'Organization'
}
